export default __webpack_public_path__ + "static/media/WartsilaeFincantierinuovisistemielettriciperlindustriadelmare.99fd246c.pdf";